// TYPES
import { ReducerActionRotaSP } from 'store/modules/types';
import { IConsultarRelacaoUsuarioRequest, Types } from './types';

export function consultarRelacaoUsuarioRequest(
	token: string,
	payload: IConsultarRelacaoUsuarioRequest,
): ReducerActionRotaSP {
	return {
		type: Types.CONSULTAR_RELACAO_USUARIO_REQUEST,
		token,
		payload,
	};
}

export function consultaRelacaoUsuarioSuccess(
	payload: object,
): ReducerActionRotaSP {
	return {
		type: Types.CONSULTAR_RELACAO_USUARIO_SUCCESS,
		payload,
	};
}

export function consultarRelacaoUsuarioClear(): ReducerActionRotaSP {
	return {
		type: Types.CONSULTAR_RELACAO_USUARIO_CLEAR,
		payload: null,
	};
}

export function consultarRelacaoUsuarioFailure(): ReducerActionRotaSP {
	return {
		type: Types.CONSULTAR_RELACAO_USUARIO_FAILURE,
		payload: null,
	};
}
